interface LessonArgs {
  lessonId: string | number;
  sectionId: string | number;
  spaceSlug: string;
}

interface ShowLessonCommentArgs extends LessonArgs {
  commentId: string;
  parentMessageId?: string;
}

export const coursePaths = {
  showLesson: ({ spaceSlug, sectionId, lessonId }: LessonArgs) =>
    `/c/${spaceSlug}/sections/${sectionId}/lessons/${lessonId}`,
  showLessonComment: ({
    spaceSlug,
    sectionId,
    lessonId,
    commentId,
    parentMessageId,
  }: ShowLessonCommentArgs) =>
    parentMessageId
      ? `/c/${spaceSlug}/sections/${sectionId}/lessons/${lessonId}?message_id=${commentId}#message_${parentMessageId}`
      : `/c/${spaceSlug}/sections/${sectionId}/lessons/${lessonId}#message_${commentId}`,
  editLesson: ({ spaceSlug, sectionId, lessonId }: LessonArgs) =>
    `/c/${spaceSlug}/edit-lesson/sections/${sectionId}/lessons/${lessonId}`,
};
